import _ from 'lodash';

export default (...watchProperties) => {
    watchProperties.push('idParam');
    watchProperties = _.uniq(watchProperties);

    const watches = {};
    watchProperties.forEach((x) => {
        watches[x] = function () {
            if (this.load) {
                window.scrollTo(0, 0);
                this.load();
            }
        };
    });
    return {
        computed: {
            idParam() {
                return this.$route.params.id;
            },
        },
        mounted() {
            if (this.load) {
                this.load();
            }
        },
        watch: watches,
    };
};
